import config from 'config';
import { http_client } from './api';

const getList = async (type = null, query = null) => {
  return http_client.get(config.apiUrl + 'latihan/list/' + type, query).then((response) => {
    return response.data;
  });
};

const getListArchive = async (type = null, query = null) => {
  return http_client.get(config.apiUrl + 'latihan/archive/' + type, query).then((response) => {
    return response.data;
  });
};

const getAlHistory = async (query = null) => {
  return http_client.get(config.apiUrl + 'latihan/history', query).then((response) => {
    return response.data;
  });
};

const create = async (data) => {
  return http_client.post(config.apiUrl + 'latihan', data).then((response) => {
    return response.data;
  });
};

const read = async (id) => {
  return http_client.get(config.apiUrl + 'latihan/' + id).then((response) => {
    return response.data;
  });
};

const update = async (id, data) => {
  return http_client.patch(config.apiUrl + 'latihan/' + id, data).then((response) => {
    return response.data;
  });
};

const del = async (id) => {
  return http_client.delete(config.apiUrl + 'latihan/' + id).then((response) => {
    return response.data;
  });
};

const getHistory = async (latihanID, query) => {
  return http_client.get(config.apiUrl + 'latihan/' + latihanID + '/history', query).then((response) => {
    return response.data;
  });
};

const sessionScore = async (data) => {
  return http_client.post(config.apiUrl + 'latihan/session/score', data).then((response) => {
    return response.data;
  });
};

const changeStatus = async (id, data) => {
  return http_client.post(config.apiUrl + 'latihan/status/' + id, data).then((response) => {
    return response.data;
  });
};

const getRatings = async (id, query = null) => {
  return http_client.get(config.apiUrl + 'latihan/' + id + '/ratings', query).then((response) => {
    return response.data;
  });
};

const copyLatihan = async (id, name, createdBy = null) => {
  return http_client.post(config.apiUrl + 'latihan/' + id + '/copy', { name, created_by: createdBy }).then((response) => {
    return response.data;
  });
};

const getShares = async (latihanId) => {
  return http_client.get(config.apiUrl + 'latihan/' + latihanId + '/shares').then((response) => {
    return response.data;
  });
};

const getEligibleTeachers = async (latihanId) => {
  return http_client.get(config.apiUrl + 'latihan/' + latihanId + '/shares/eligible').then((response) => {
    return response.data;
  });
};

const getEligibleForCopy = async (latihanId) => {
  return http_client.get(config.apiUrl + 'latihan/' + latihanId + '/shares/eligible', { params: { for_copy: true } }).then((response) => {
    return response.data;
  });
};

const addShares = async (latihanId, teacherIds) => {
  return http_client.post(config.apiUrl + 'latihan/' + latihanId + '/shares', { teacher_ids: teacherIds }).then((response) => {
    return response.data;
  });
};

const removeShare = async (latihanId, teacherId) => {
  return http_client.delete(config.apiUrl + 'latihan/' + latihanId + '/shares/' + teacherId).then((response) => {
    return response.data;
  });
};

const LatihanService = {
  getList,
  getListArchive,
  getAlHistory,
  create,
  read,
  update,
  del,
  getHistory,
  sessionScore,
  changeStatus,
  getRatings,
  copyLatihan,
  getShares,
  getEligibleTeachers,
  getEligibleForCopy,
  addShares,
  removeShare
};

export default LatihanService;
